import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface RecurrenceSyncDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  oldAmount: number;
  newAmount: number;
  onConfirm: () => void;
  onDecline: () => void;
}

export function RecurrenceSyncDialog({
  open,
  onOpenChange,
  oldAmount,
  newAmount,
  onConfirm,
  onDecline,
}: RecurrenceSyncDialogProps) {
  const formatCurrency = (value: number) =>
    new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Atualizar transações recorrentes?</AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <p>
              O valor mensal foi alterado de{' '}
              <strong>{formatCurrency(oldAmount)}</strong> para{' '}
              <strong>{formatCurrency(newAmount)}</strong>.
            </p>
            <p>
              Deseja atualizar as transações futuras (não pagas) da série
              recorrente vinculada com o novo valor?
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onDecline}>
            Não, manter valores separados
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            Sim, atualizar transações
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
